import { useCallback, useEffect, useState } from "react";
import { adminApi } from "../lib/adminApi";
import { reportError } from "../lib/reportError";

export const useAdminPayments = () => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    adminApi.get("/auth/me").then(({ data }) => { if (active) setUser(data); })
      .catch(error => { if (error.response?.status !== 401) reportError("Admin session unavailable", error); })
      .finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, []);
  const load = useCallback(async () => {
    setLoading(true); setError("");
    try { const { data } = await adminApi.get("/admin/bank-payments"); setPayments(data); }
    catch (error) {
      reportError("Admin payments could not be loaded", error);
      if (error.response?.status === 401) { setUser(null); setPayments([]); }
      setError("Payments could not be loaded. Please sign in again or retry.");
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { if (user) void load(); }, [user, load]);
  const login = async (email, password) => {
    const { data } = await adminApi.post("/auth/login", { email, password });
    setUser(data); setError("");
  };
  const logout = async () => {
    try { await adminApi.post("/auth/logout"); setUser(null); setPayments([]); }
    catch (error) { reportError("Admin logout failed", error); setError("Could not sign out. Please try again."); }
  };
  return { user, checking, payments, loading, error, login, logout, reload: load };
};